import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AdminDashboard from '../pages/admin/Dashboard';
import AdminProducts from '../pages/admin/products/ProductsList';
import AdminProductForm from '../pages/admin/products/ProductForm';
import AdminOrders from '../pages/admin/orders/OrdersList';
import AdminSettings from '../pages/admin/settings';
import AdminCategories from '../pages/admin/categories';
// Importar a nova página de subcategorias
import AdminSubcategoriesPage from '../pages/admin/subcategories'; 
import AdminLogin from '../pages/admin/login';
import AdminRegister from '../pages/admin/login/register';
import ForgotPassword from '../pages/admin/login/forgot-password';
import ResetPassword from '../pages/admin/login/reset-password';
import AdminCustomersPage from '../pages/admin/customers';
import CustomerForm from '../pages/admin/customers/CustomerForm';
import AdminUsersPage from '../pages/admin/admins';
import AdminForm from '../pages/admin/admins/AdminForm';
import ChangePassword from '../pages/admin/change-password';
import AdminActivityLogsPage from '../pages/admin/activity-logs';
import NewsletterPage from '../pages/admin/newsletter';
import AdminLayout from '../pages/admin/Layout';
import AdminProtectedRoute from '../components/admin/AdminProtectedRoute'; // Import the guard

const AdminRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Public admin routes */}
      <Route path="/login" element={<AdminLogin />} />
      <Route path="/register" element={<AdminRegister />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      {/* Protected admin routes */}
      <Route
        path="/"
        element={
          <AdminProtectedRoute>
            <AdminLayout />
          </AdminProtectedRoute>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="products" element={<AdminProducts />} />
        <Route path="products/new" element={<AdminProductForm />} />
        <Route path="products/:id" element={<AdminProductForm />} />
        <Route path="orders" element={<AdminOrders />} />
        <Route path="settings" element={<AdminSettings />} />
        <Route path="categories" element={<AdminCategories />} />
        {/* Adicionar a rota para subcategorias */}
        <Route path="subcategories" element={<AdminSubcategoriesPage />} /> 
        <Route path="customers" element={<AdminCustomersPage />} />
        <Route path="customers/new" element={<CustomerForm />} />
        <Route path="customers/edit/:id" element={<CustomerForm />} />
        <Route path="admins" element={<AdminUsersPage />} />
        <Route path="admins/edit/:id" element={<AdminForm />} />
        <Route path="activity-logs" element={<AdminActivityLogsPage />} />
        <Route path="newsletter" element={<NewsletterPage />} />
        <Route path="change-password" element={<ChangePassword />} />
      </Route>
    </Routes>
  );
};

export default AdminRoutes;